export default "<app-criteria criteria=\"product\">\r\n"